/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RemoveDashboardWidgetRequestBody,
  RemoveDashboardWidgetRequestBody$Outbound,
  RemoveDashboardWidgetRequestBody$outboundSchema,
} from "../components/removedashboardwidgetrequestbody.js";

export type RemoveDashboardWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RemoveDashboardWidgetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  removeDashboardWidgetRequestBody: RemoveDashboardWidgetRequestBody;
};

/** @internal */
export type RemoveDashboardWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RemoveDashboardWidgetSecurity$outboundSchema: z.ZodMiniType<
  RemoveDashboardWidgetSecurity$Outbound,
  RemoveDashboardWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function removeDashboardWidgetSecurityToJSON(
  removeDashboardWidgetSecurity: RemoveDashboardWidgetSecurity,
): string {
  return JSON.stringify(
    RemoveDashboardWidgetSecurity$outboundSchema.parse(
      removeDashboardWidgetSecurity,
    ),
  );
}

/** @internal */
export type RemoveDashboardWidgetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RemoveDashboardWidgetRequestBody: RemoveDashboardWidgetRequestBody$Outbound;
};

/** @internal */
export const RemoveDashboardWidgetRequest$outboundSchema: z.ZodMiniType<
  RemoveDashboardWidgetRequest$Outbound,
  RemoveDashboardWidgetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    removeDashboardWidgetRequestBody:
      RemoveDashboardWidgetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      removeDashboardWidgetRequestBody: "RemoveDashboardWidgetRequestBody",
    });
  }),
);

export function removeDashboardWidgetRequestToJSON(
  removeDashboardWidgetRequest: RemoveDashboardWidgetRequest,
): string {
  return JSON.stringify(
    RemoveDashboardWidgetRequest$outboundSchema.parse(
      removeDashboardWidgetRequest,
    ),
  );
}
